if (!customElements.get("component-custom-reviews")) {
  class TrustedSlider extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      if (this.swiper && typeof this.swiper.destroy === "function") {
        this.swiper.destroy(true, true);
      }
      this.swiper = null;
    }

    init() {
      if (typeof Swiper === "undefined") return;

      const swiperRoot = this.querySelector(".custom-reviews__swiper");
      if (!swiperRoot) return;

      const prevEl = this.querySelector(".custom-reviews__prev");
      const nextEl = this.querySelector(".custom-reviews__next");

      this.swiper = new Swiper(swiperRoot, {
        slidesPerView: 3,
        spaceBetween: 24,
        grabCursor: true,
        watchOverflow: true,
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl,
        },
        breakpoints: {
          768: {
            slidesPerView: 2.1,
            spaceBetween: 16,
          },
          640: {
            slidesPerView: 1.24,
            spaceBetween: 16,
          },
        },
      });
    }
  }

  customElements.define("component-custom-reviews", TrustedSlider);
}

